import React from 'react';

import QuizHeaderControls from '../__header-controls/quiz__header-controls';
import { SimpleCallback } from '../../../typings';
import { useStaticUrls } from '../../../utils/hooks/useStaticUrls';
import { UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import SimpleLogo from '../../logo/_type/logo_type_simple';
import ReturnButton from '../../return-button/return-button';
import Text from '../../text/text';
import { TEACHER_QUIZ_MODE } from '../constants';

import './quiz__header.scss';

interface Props {
    mode: TEACHER_QUIZ_MODE;
    onlineStudentsCount: number;
    onReturnButtonClick: SimpleCallback;
    isGameSelected?: boolean;
    handleMainButtonClick?: SimpleCallback;
    handleStatButtonClick?: SimpleCallback;
    isLastQuestion?: boolean;
    isStatButtonDisabled?: boolean;
    questionIndex: number | null;
    totalQuestions?: number;
}

const QuizHeader = (props: Props) => {
    const {
        mode,
        onlineStudentsCount,
        onReturnButtonClick,
        isGameSelected,
        handleMainButtonClick,
        handleStatButtonClick,
        isLastQuestion,
        isStatButtonDisabled,
        questionIndex,
        totalQuestions = 0,
    } = props;
    const { labHome } = useStaticUrls();

    const shouldShowReturnButton =
        isGameSelected && [TEACHER_QUIZ_MODE.START_SCREEN, TEACHER_QUIZ_MODE.FINAL_SCREEN].includes(mode);
    const shouldShowQuestionCounter = [TEACHER_QUIZ_MODE.QUESTION, TEACHER_QUIZ_MODE.STATISTICS].includes(mode);

    return (
        <div className="quiz-teacher__header">
            <div className="quiz-teacher__left-column">
                <div className="quiz-teacher__header-service">
                    <SimpleLogo className="quiz-teacher__header-logo" isRouter={true} to={labHome} />
                    {shouldShowReturnButton && (
                        <ReturnButton mix="quiz-teacher__return-button" onClick={onReturnButtonClick} />
                    )}
                </div>
                {shouldShowQuestionCounter && questionIndex !== null && (
                    <Text
                        className="quiz-teacher__counter"
                        id="quiz.questionCounter"
                        typography={UI_KIT_TEXT_TYPOGRAPHY.headlineXSMedium}
                        values={{ index: questionIndex + 1, length: totalQuestions }}
                    />
                )}
            </div>
            {isGameSelected && (
                <QuizHeaderControls
                    handleMainButtonClick={handleMainButtonClick}
                    handleStatButtonClick={handleStatButtonClick}
                    isLastQuestion={isLastQuestion}
                    isStatButtonDisabled={isStatButtonDisabled}
                    mode={mode}
                    onlineStudentsCount={onlineStudentsCount}
                />
            )}
        </div>
    );
};

export default QuizHeader;
